import React from "react";
import ServiceBannerImage from "../../assets/img/services-hero.jpg";

export default function ServicesBanner() {
  return (
    <section className="relative w-full h-screen overflow-hidden">
test
    </section>
  );
}
